import { type ImageSource } from 'expo-image'
import { type ImageSourcePropType } from 'react-native'

export type MinimalPhoto = {
  blurhash?: string | null | undefined
  description?: string | null | undefined
  isPrimary?: boolean
  rowId?: string | null | undefined
  source: ImageSource | ImageSourcePropType | null | undefined
}
